import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const MediaIcon: React.FC<IconProps> = ({ className = '', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="3" y="4" width="18" height="12" rx="2" ry="2" />
    <line x1="2" y1="20" x2="22" y2="20" />
    <circle cx="8" cy="9" r="2" />
    <path d="M16 12l-4-4-4 4" />
  </svg>
); 